<script lang="ts" setup></script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <rect
      x="9"
      y="17.9995"
      width="1"
      height="4"
      transform="rotate(90 9 17.9995)"
      fill="currentColor"
    />
    <rect
      x="20"
      y="5.99951"
      width="1"
      height="15"
      transform="rotate(90 20 5.99951)"
      fill="currentColor"
    />
    <rect
      x="14"
      y="11.9995"
      width="1"
      height="9"
      transform="rotate(90 14 11.9995)"
      fill="currentColor"
    />
  </svg>
</template>
